<template>
  <div class="description">
    <template v-if="tags && tags.length && tags.includes('好车西运')">
      <div class="desc--westward-wrapper">
        <div class="desc--westward-label">
          <div class="decs-westward-label__text">
            好车西运
          </div>
        </div>
        上海总部集采车源，每周板车直发成都
      </div>
    </template>
    <template v-if="!wholesale && warranty && warranty.important_remark">
      <div class="paragraph-wrapper">
        0）除标准自营车保障外，该车还享受“加强保障项目”，进一步减少后顾之忧：
      </div>
      <template
        v-for="(remark, remarkIndex) in warranty.important_remark"
        :key="remarkIndex">
        <div
          style="color: #0070e0"
          class="paragraph-wrapper">
          {{ remark.title }}
        </div>
      </template>
    </template>
    <template v-if="notes">
      <template
        v-for="(paragraph, paragraphIndx) in notes"
        :key="paragraphIndx">
        <div class="paragraph-wrapper">
          {{ paragraph }}
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Description',

  data: () => ({}),

  computed: {
    ...mapGetters('Car', [
      'wholesaleByCarId',
      'warrantyByCarId',
      'notesByCarId',
      'tagsByCarId',
    ]),

    carId () {
      return this.$route.params.id
    },

    wholesale () {
      return this.wholesaleByCarId(this.carId)
    },

    warranty () {
      return this.warrantyByCarId(this.carId)
    },

    notes () {
      const notes = this.notesByCarId(this.carId)

      if (!notes || !notes.length) {
        return null
      }
      else {
        return _
          .chain(notes)
          .split('\n')
          .reject((item) => {
            return _.trim(item) === ''
          })
          .value()
      }
    },

    // tags
    // - 2025.01.14
    tags () {
      return this.tagsByCarId(this.carId)
    },
  },
}
</script>

<style lang="scss" scoped>
.description {
  color: #616161;
  white-space: pre-line;
}

.paragraph-wrapper {
  font-size: 1.025rem;
  line-height: 1.475;
  margin-bottom: 8px;
}

.desc--westward-wrapper {
  display: flex;
  font-weight: bold;
  color: var(--black-primary);
  align-items: center;
  margin-bottom: 10px;
  font-size: .85rem;
}

.desc--westward-label {
  font-size: .8rem;
  margin-left: 2px;
  color: #FFFFFF;
  background: linear-gradient(0deg, #FFDC81 0%, #C3914D 100%);
  display: inline-block;
  padding: 0 7px;
  border-radius: 10px 0 10px 0;
  transform: skew(-10deg);
  margin-right: 3px;
  margin-right: 5px;
}

.decs-westward-label__text {
  display: inline-block;
  transform: skew(10deg);
  font-weight: bold;
  text-shadow: 0rpx 1rpx 4rpx rgba(0, 0, 0, .2);
}

@media (min-width: 640px) {
  .paragraph-wrapper {
    font-size: 1rem;
    line-height: 1.625;
    margin-bottom: 14px;
  }
}

@media (prefers-color-scheme: dark) {
  .description {
    color: var(--black-primary);
  }

  .desc--westward-label {
    background: #725227;
  }
}
</style>
